import api from './api';

const founderKpiService = {
  getFounderKpis: async (month) => {
    const params = month ? { month } : {};
    const response = await api.get('/main-dashboard/founder-kpis', { params });
    return response.data;
  }
};

export default founderKpiService;
